<header>
  <!-- Fixed navbar -->
  <!-- <nav class="bg-white border-gray-200 sm:px-4 py-4 md:py-0 px-4 rounded fixed w-full z-20 top-0 left-0 border-b">
    <div class="container flex flex-wrap items-center justify-between mx-auto">
      <a href="#" class="flex items-center">
          <img src="assets/images/ladybird.svg" class="h-6 mr-3 sm:h-9" alt="Ladybird silhouette" />
      </a>
      <div class="hidden w-full md:block md:w-auto" id="navbar-default">
        <ul class="flex flex-col p-4 mt-4 border border-gray-100 rounded-lg bg-gray-50 md:flex-row md:space-x-8 md:mt-0 md:text-sm md:font-medium md:border-0 md:bg-white">
          <li *ngIf="(isAuthenticated$ | async) === true">
            <a href="#" class="block py-2 pl-3 pr-4 text-gray-700 rounded hover:border-gray-200 hover:md:border-gray-200 md:hover:text-blue-700 md:p-0" routerLink="/bands">Bands</a>
          </li>
          <li *ngIf="(isAuthenticated$ | async) === true">
            <a href="#" class="block py-2 pl-3 pr-4 text-gray-700 rounded hover:border-gray-200 hover:md:border-gray-200 md:hover:text-blue-700 md:p-0" routerLink="/users">Users</a>
          </li>
          <li *ngIf="(isAuthenticated$ | async) === false">
            <a href="#" class="block py-2 pl-3 pr-4 text-gray-700 rounded hover:border-gray-200 hover:md:border-gray-200 md:hover:text-blue-700 md:p-0" routerLink="/account">Login</a>
          </li>
          <li *ngIf="(isAuthenticated$ | async) === true">
            <a href="#" class="block py-2 pl-3 pr-4 text-gray-700 rounded hover:border-gray-200 hover:md:border-gray-200 md:hover:text-blue-700 md:p-0" routerLink="/account-settings">User Account</a>
          </li>
          <li *ngIf="(isAuthenticated$ | async)  === true">
            <a href="#" class="block py-2 pl-3 pr-4 text-gray-700 rounded hover:border-gray-200 hover:md:border-gray-200 md:hover:text-blue-700 md:p-0" (click)="logOut()">Logout</a>
          </li>
        </ul>
      </div>
    </div>
  </nav> -->
</header>
